// extracted by mini-css-extract-plugin
export default {"stockOptions":"StockOperations_stockOptions__uaQXc","quantity":"StockOperations_quantity__bdk1K"};